module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"description_with_reward":"다음 키워드에 대해 쓰면, AI 분석 후 추가 적립금 지급","description_wihout_reward":"다음 키워드에 대해 작성해보세요"}}')
  delete Component.options._Ctor
}
